import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {applyMiddleware, createStore, Store} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import thunk from "redux-thunk";
import App from "src/App";
import AppWrapper from "src/HOC/AppWrapper";
import registerServiceWorker from "src/registerServiceWorker";
import "./index.scss";
import {rootReducer} from "./store";
import {IStateApp} from "./store/StoreInterface";

const store: Store<IStateApp> = createStore(
	rootReducer,
	composeWithDevTools(applyMiddleware(thunk))
);

const app = (
	<Provider store={store}>
		<AppWrapper>
			<App/>
		</AppWrapper>
	</Provider>
);

ReactDOM.render(app, document.getElementById("root") as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx